import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type CreateAccountDivisionMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateAccountDivisionInput;
}>;

export type CreateAccountDivisionMutationResult = { __typename?: 'Mutation' } & {
  createAccountDivision?: GraphQLTypes.Maybe<
    { __typename?: 'CreateAccountBusinessUnitPayload' } & Pick<GraphQLTypes.CreateAccountBusinessUnitPayload, 'accountId'> & {
        errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
      }
  >;
};

export const CreateAccountDivisionDocument = gql`
  mutation createAccountDivision($input: CreateAccountDivisionInput!) {
    createAccountDivision(input: $input) {
      accountId
      errors {
        message
        path
      }
    }
  }
`;
